import { CardHeading } from './CardHeading';

export default CardHeading;
